const $simple_map = function () {
    "use strict";
    
    const definitions = [
        { id: 1, label: "Mexico", images: [ 2 ] },
        { id: 2, label: "Portugal", images: [ 2 ] },
        { id: 3, label: "Spain", images: [ 2 ] },
        { id: 4, label: "Switzerland", images: [ 2 ] },
        { id: 5, label: "Germany", images: [ 2 ] },
        { id: 6, label: "United Kingdom", images: [ 2 ] },
        { id: 7, label: "France", images: [ 2 ] },
        { id: 8, label: "Brazil", images: [ 2 ] },
        { id: 9, label: "Curaçao", images: [ 1 ] },
        { id: 10, label: "Dominican Republic", images: [ 1 ] },
        { id: 11, label: "Puerto Rico", images: [ 1 ] },
        { id: 12, label: "Panama", images: [ 1, 2 ] },
        { id: 13, label: "Venezuela", images: [ 1, 2 ] },
        { id: 14, label: "Florida", images: [ 1, 2 ] },
    ];
    
    let dom_svg = `svg#simple-map`,
        dom_svg_group = `svg#simple-map g[data-group]`,
        dom_tooltip = `div.map div.tooltip`;
    
    function getDefinition( id ) {
        let d = definitions.find( function ( definition ) {
            return definition.id === id;
        });
        
        let images = d.images.map( function ( image ) {
            return `<img src="${$globals.template_directory + "/blocks-general/simple-map/assets/svg/image-" + image + ".svg"}">`;
        });
        
        return `<div class="html">
            ${images.join( "" )}
            <span>${d.label}</span>
        </div>`;
    }
    
    function onGroupMouseEnter() {
        if ( jQuery( dom_svg ).length > 0 ) {
            jQuery( document ).off( "mouseenter", dom_svg_group ).on( "mouseenter", dom_svg_group, function ( e ) {
                e.preventDefault();
                e.stopPropagation();
                
                let r = jQuery( this )[ 0 ].getBoundingClientRect();
                
                if ( jQuery( this ).hasClass( "is-hovered" ) === false ) {
                    let tooltip = jQuery( dom_tooltip ),
                        id = parseInt( jQuery( this ).attr( "data-group" ) );
                    
                    tooltip.html( getDefinition( id ) );
                    
                    let group_x = r.x + ( r.width / 2 ) - ( tooltip.outerWidth() / 2 ),
                        group_y = r.y - tooltip.outerHeight();
                    
                    tooltip.css({
                        "top": group_y,
                        "left": group_x
                    });
                    
                    jQuery( dom_svg_group ).removeClass( "is-hovered" );
                    jQuery( this ).addClass( "is-hovered" );
                    
                    setTimeout( function () {
                        tooltip.addClass( "is-visible has-effects" );
                    }, 100 );
                }
            });
        }
    }
    
    function onWindowScroll() {
        if ( jQuery( dom_svg ).length > 0 ) {
            jQuery( window ).on( "scroll", function ( e ) {
                let tooltip = jQuery( dom_tooltip );
                
                jQuery( dom_svg_group ).removeClass( "is-hovered" );
                tooltip.removeClass( "is-visible" );
            });
        }
    }
    
    $simple_map.run = function () {
        onGroupMouseEnter();
        onWindowScroll();
    };
    
    return $simple_map;
};

jQuery( document ).ready( function () {
    $simple_map().run();
});
